import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { SlotCreditBalanceStat } from '../slot-credit-balance-stat.model';

@JsonObject('SlotCreditBalanceResultsResponse')
export class SlotCreditBalanceResultsResponse extends ApiResultsResponse<SlotCreditBalanceStat> {

  @JsonProperty('results', [SlotCreditBalanceStat])
  override results: SlotCreditBalanceStat[] = [];
}
